import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Footer from "components/user/Footer";
import Header from "components/user/Header";
import About from "./About";


function Home() {
 

  return (
    <>

      <Header />
     
      <About />

      <div className="mt-10">
        <Footer />
      </div>

    </>
  );
}

export default Home;
